import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { InputFieldBaseComponent } from './input-field-base.component';
import { UiField } from '../ui-form';
import { getISODateStringIgnoringTimezone } from '@mng/mng-ts-helpers';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { NgStyle } from '@angular/common';
import {
  MatDatepickerToggle,
  MatDateRangeInput,
  MatDateRangePicker,
  MatEndDate,
  MatStartDate
} from '@angular/material/datepicker';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'mng-inputfield-date-range',
  imports: [
    MatFormField,
    NgStyle,
    MatSuffix,
    MatLabel,
    MatDateRangeInput,
    MatStartDate,
    ReactiveFormsModule,
    MatEndDate,
    MatDatepickerToggle,
    MatSuffix,
    MatDateRangePicker,
    MatError
  ],
  templateUrl: './input-field-date-range.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputFieldDateRangeComponent extends InputFieldBaseComponent {
  readonly min = input<Date>();
  readonly max = input<Date>();
  readonly bisDatumField = input<UiField>();
  readonly label = input('Von / Bis Datum');

  setValueAsISOString(which: 'von' | 'bis', value: Date | null) {
    if (value) {
      const isoDate = getISODateStringIgnoringTimezone(value);
      if (which === 'bis') {
        this.bisDatumField().control.setValue(isoDate);
      } else {
        this.field().control.setValue(isoDate);
      }
    }
  }
}
